import { render, staticRenderFns } from "./expense_group.vue?vue&type=template&id=34416131&scoped=true"
import script from "./expense_group.vue?vue&type=script&lang=js"
export * from "./expense_group.vue?vue&type=script&lang=js"
import style0 from "./expense_group.vue?vue&type=style&index=0&id=34416131&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34416131",
  null
  
)

export default component.exports